import { render } from "./builder_new.vue?vue&type=template&id=289acefd"
import script from "./builder_new.vue?vue&type=script&lang=js"
export * from "./builder_new.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__